import type { LDClient } from 'launchdarkly-js-client-sdk';

export const INIT_TIMEOUT_SEC = 5;

let bridgedClient: LDClient | undefined;

export function setLDClient(client: LDClient): void {
	bridgedClient = client;
}

export function getLDClient(): LDClient {
	if (!bridgedClient) {
		throw new Error(
			'LaunchDarkly client is not registered. Ensure LDPlugin runs and setLDClient is called from app.runWithContext in main.ts.',
		);
	}
	return bridgedClient;
}

export async function getLDClientWhenReady(): Promise<LDClient> {
	const client = getLDClient();
	await client.waitForInitialization(INIT_TIMEOUT_SEC);
	return client;
}
